import get from 'lodash/get'

import { EightxEightEventAttributes } from 'lib/models/eight-x-eight-event'

const FETCH_EIGHT_X_EIGHT_EVENTS_FOR_CUSTOMER =
  'FETCH_EIGHT_X_EIGHT_EVENTS_FOR_CUSTOMER'

export type EightXEightEventsState = {
  /** The latest request. A response to any other request finished late, e.g.
   * after moving to another lead, so it's ignored. */
  requestId: string | null
  events: EightxEightEventAttributes[]
}

const initialState: EightXEightEventsState = { requestId: null, events: [] }

export default function eightXEightEvents(
  state = initialState,
  action: { type?: string; meta?: { requestId?: string } } = {}
): EightXEightEventsState {
  const isLatestRequest = action.meta?.requestId === state.requestId

  switch (action.type) {
    case FETCH_EIGHT_X_EIGHT_EVENTS_FOR_CUSTOMER + '_PENDING':
      return { requestId: action.meta?.requestId ?? null, events: [] }

    case FETCH_EIGHT_X_EIGHT_EVENTS_FOR_CUSTOMER + '_FULFILLED':
      if (!isLatestRequest) return state
      return { ...state, events: get(action, 'payload.data.data', []) }

    case FETCH_EIGHT_X_EIGHT_EVENTS_FOR_CUSTOMER + '_REJECTED':
      if (!isLatestRequest) return state
      return { ...state, events: [] }

    default:
      return state
  }
}
